


import React, { useEffect, useState, useRef } from 'react';
import { HubConnectionBuilder, HubConnection, LogLevel } from '@microsoft/signalr';

import Layout from "../../components/Layout/AdminLayout/AdminLayout";

import helpers from '../../helpers/index';

import MessageModal from '../../components/Modal/MessageModal';
import ImportingModal from '../../components/Modal/ImportingModal';
import ImportLogModal from '../../components/Modal/ImportLogModal';

import warningIcon from '../../assets/warning-icon.png';
import infoIcon from '../../assets/info-icon.png';


import { ApiResponse } from '../../interface/IResponse';
import { ImportLog } from '../../interface/IImport'
import importService from './importService';
import { AxiosResponse } from 'axios';

import ImportLogTable from '../../components/Table/Import/ImportLogTable';

import { ImportMemberLog } from "../../interface/IImport";



function ImportPage() {

    interface Message {
        user: string;
        message: string;
    }

    const [isReadOnly, setIsReadOnly] = useState(false);
    const [connection, setConnection] = useState<HubConnection | null>(null); useState<HubConnection | null>(null);
    const [importStatusMessages, setImportStatusMessages] = useState<Message>();
    const [importLogList, setImportLogList] = useState<ImportLog[]>([]);
    const [modalLogOpen, setModalLogOpen] = useState(false);
    const [modalLogMessage, setModalLogMessage] = useState('');
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [importingModalOpen, setImportingModalOpen] = useState(false);
    const [importLog, setImportLog] = useState<ImportMemberLog[]>([]);
    const fileInputLoanRef = useRef<HTMLInputElement | null>(null);
    const [isShowOkButton, setIsShowOkButton] = useState(false);



    function getPermission() {

        var permission = helpers.getPermission();
        setIsReadOnly(permission == "ReadOnly");
    }

    function onClose() {
        setModalLogOpen(false);
    }

    async function getImportLogList() {
        try {

            var response: AxiosResponse<ApiResponse<ImportLog[]>> = await importService.getImportLogList();

            setImportLogList(response.data.result);

        }
        catch (err) {
            console.log('getImportLogList:: ', err);

        }
    }

    async function getImportMemberLogs(hangfireImportId: number) {

        try {
            var response: AxiosResponse<ApiResponse<ImportMemberLog[]>> = await importService.getImportLogsList(hangfireImportId);

            if (response && response.data && response.data.result) {
                setImportLog(response.data.result);
            }

        }
        catch (err) {
            console.log('getImportMemberLogs error:: ', importService);
        }

    }

    async function viewLog(hangfireImportId: number, importLog: string) {
        document.querySelector('.loader-container')?.classList.add('loader');
        
        await getImportMemberLogs(hangfireImportId);
        setModalLogMessage(importLog);
        setModalLogOpen(true);


        document.querySelector('.loader-container')?.classList.remove('loader');

    }

    function setImportMessageData(input: Message) {

        setImportStatusMessages(input);

        if (input.message) {
            setImportingModalOpen(true);
        }

    }

    useEffect(() => {
        // Initialize SignalR connection
        const newConnection = new HubConnectionBuilder()
            .withUrl(`${process.env.REACT_APP_IMPORT_URL_HUB}/hubs/import`, {
               withCredentials: true
            })  // Match the .NET Core hub endpoint
            .configureLogging(LogLevel.Information)
            .build();

        setConnection(newConnection);

        newConnection.start()
            .then(async () => {
                console.log("Connected to the hub");
                await newConnection.invoke("JoinRoom", "ImportChatRoom"); // Join the room
            })
            .catch(err => console.error("Connection failed: ", err));

        return () => {
            newConnection.stop();
        };
    }, []);

    useEffect(() => {
        if (connection) {
            connection.on("ReceiveMessage", (user, message) => {

                setImportMessageData({ user, message });
                console.log(`${user} --- ${message}`);
            });

            connection.onclose(() => {
                console.log("Connection closed");
            });
        }
    }, [connection]);

    useEffect(function () {
        (async () => {

            document.querySelector('.loader-container')?.classList.add('loader');

            await getImportLogList();
            getPermission();

            document.querySelector('.loader-container')?.classList.remove('loader');
        })();
    }, []);

    return (
        <Layout>
            {/* <MessageModal icon={warningIcon} message={modalLogMessage} isOpen={modalLogOpen} onClose={onClose} /> */}
            <ImportingModal icon={infoIcon} message={(importStatusMessages?.message) ? importStatusMessages?.message : ""} isOpen={importingModalOpen} isShowOkButton={isShowOkButton} onClose={function () {
                // setImportingModalOpen(false);
                window.location.reload();
            }} />

            <ImportLogModal message="" importLogs={importLog} isOpen={modalLogOpen} onClose={onClose} />

            <div style={{ display: 'flex', justifyContent: 'center' }} className='title-container'>
                <h1>
                    Data Import
                </h1>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <button type="button" id="btnImportMember"
                    disabled={isReadOnly}
                    className="btn-green-1 center-middle"
                    onClick={() => {
                        fileInputRef.current?.click();
                    }}
                >Import Member</button>
                <input type="file" style={{ display: 'none' }} accept=".csv" ref={fileInputRef} onChange={(event) => {
                    const file = event.target.files?.[0];
                    if (file) {
                        const reader = new FileReader();
                        reader.onload = async () => {
                            if (reader.result) {
                                setIsShowOkButton(false);
                                document.querySelector('.loader-container')?.classList.add('loader');
                                var base64String = reader.result.toString().replace(/^data:text\/csv;base64,/, '');
                                console.log('base64 test:: ', base64String);

                                await importService.uploadMembersImportCsv({ originalFilename: file.name, moduleEnumId: 1, csvBase64: base64String });

                                document.querySelector('.loader-container')?.classList.remove('loader');

                                // setImportMessageData({ "user": "", "message": "Importing........" });
                                setIsShowOkButton(true);
                            }
                        };
                        reader.onerror = () => {
                            console.error('Error reading file.');
                        };
                        reader.readAsDataURL(file); // Convert file to Base64

                    }
                }} />

                <button type="button" id="btnImportLoan" style={{ marginLeft: '50px' }}
                    disabled={isReadOnly}
                    className="btn-green-1 center-middle"
                    onClick={() =>{
                        fileInputLoanRef.current?.click()
                    }}
                    >Import Loan</button>
                     <input type="file" style={{ display: 'none' }} accept=".csv" ref={fileInputLoanRef} onChange={(event) => {
                    const file = event.target.files?.[0];
                    if (file) {
                        const reader = new FileReader();
                        reader.onload = async () => {
                            if (reader.result) {
                                setIsShowOkButton(false);
                                document.querySelector('.loader-container')?.classList.add('loader');
                                var base64String = reader.result.toString().replace(/^data:text\/csv;base64,/, '');
                                console.log('base64 test:: ', base64String);

                                await importService.uploadLoanImportCsv({ originalFilename: file.name, moduleEnumId: 1, csvBase64: base64String });
                                
                                document.querySelector('.loader-container')?.classList.remove('loader');
                                
                                // setImportMessageData({"user": "", "message":"Importing........"});
                                setIsShowOkButton(true);
                            }
                        };
                        reader.onerror = () => {
                            console.error('Error reading file.');
                        };
                        reader.readAsDataURL(file); // Convert file to Base64

                    }
                }} />
            </div>

            <br />

            <div className="content-container">


                <div className="table-container">
                    <div className='title' style={{ padding: "24px 24px 0" }}>Import Log

                    </div>
                    <ImportLogTable data={importLogList} viewLog={viewLog}></ImportLogTable>
                </div>
            </div>

        </Layout>
    );
}



export default ImportPage;


